<template lang="pug">
.filtering__facet(
  @click="open = !open", 
  @keypress.enter="open = !open",
	v-if="options.length > 1")
  .filtering__select
    .filtering__selection(:class="{open}", tabindex="0")
      span {{ selected.categoryName }}
    TransitionExpand
      .filtering__options(v-if="open", :key="'options'")
        .filtering__option(
          @click="value = item.categoryId; toggleWeightedSort()", 
          @keypress.enter="value = item.categoryId", 
          :class="{selected: selected.categoryId === item.categoryId}"
          v-for="item in options", 
          tabindex="0") {{ item.categoryName }}
</template>


<script>
import TransitionExpand from '../transitions/Expand.vue'
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "FilteringFacet",
  props: ["options", "depth"],
  components: {
    TransitionExpand
  },
  data() {
    return {
      open: false
    }
  },
  computed: {
    ...mapGetters(["model", "lookup", "weightedSort"]),
    value: {
      get() {
        return this.model[this.depth];
      },
      set(v) {
        this.updateModel({ value: v, depth: this.depth });
      },
    },
    selected() {
      return this.options.find((opt) => opt.categoryId === this.value);
    },
  },
  methods: {
    ...mapMutations(["updateModel", "setWeightedSort"]),
    close(e) {
      if (e.target.closest('.filtering__facet') === this.$el) return;
      this.open = false;
    },
    toggleWeightedSort () {
      const selectedOption = this.options.find((opt) => opt.categoryId === this.value)
      // set weighted sort based on json response
      if(selectedOption.categoryWeight) {
        this.setWeightedSort(selectedOption.categoryWeight)
      } else {
        this.setWeightedSort(false)
      }
    }
  },
  created() {
    window.addEventListener('click', this.close)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.close)
  }
};
</script>

<style lang="scss" scoped>
.filtering {
  &__facet {
    display: flex;
    flex: 1 1 0;
    @include mq(md) {
      width: 0;
      max-width: calc(33.333% - (2rem/3));
    }
    &:last-child {
      .filtering__select {
        background: $teal;
        color: $white;
      }
    }
  }

  &__select {
    display: flex;
    width: 100%;
    position: relative;
    background: $white;
    border: 1px solid darken($gray, 5%);
    box-shadow: 0 0 0.25rem rgba($black, 0.075);
    transition: 0.25s ease;
    border-radius: 0.3875rem;
  }

  &__selection {
    display: flex;
    width: 100%;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    &.open {
      &::after {
        transform: rotate(135deg);
      }
    }
    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &::after {
      content: '';
      height: 0.5rem;
      width: 0.5rem;
      border-bottom: 2px solid;
      border-left: 2px solid;
      align-self: center;
      margin-left: 0.25rem;
      margin-right: 0.125rem;
      transform: rotate(-45deg);
      transition: 0.125s ease;
    }
  }

  &__options {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: calc(100% + 0.5rem);
    left: 0;
    right: 0;
    color: $fontColorBase;
    box-shadow: 0 0 0.5rem rgba($black, 0.2), 0 0 1rem rgba($black, 0.075);
    background: lighten($gray, 2.5%);
    z-index: 1000;
    border-radius: 0.3875rem;
    overflow: hidden;
  }

  &__option {
    padding: 0.5rem;
    cursor: pointer;
    font-size: 0.875rem;
    line-height: 1.2;
    transition: 0.125s ease;
    &:first-child {
      padding-top: 0.75rem;
    }
    &:hover {
      background: darken($gray, 4%);
    }
    &.selected {
      background: lighten($lightBlue, 20%);
      // color: $white;
      &:hover {
        background: lighten($lightBlue, 15%);
      }
    }
  }
}
</style>